import { CanDeactivateFn } from "@angular/router";
import { CanComponentNavigate } from "../utils/can-component-navigate";

export const componentCanNavigateGuard: CanDeactivateFn<CanComponentNavigate> = (
  component,
  currentRoute,
  currentState,
  nextState
) => {
  return component?.canNavigate();
};
